module.exports = "/_next/static/images/JettyInfo-c2bf8c0ffc1c772c7da35258dcceaa36.png";